// initialed state
export const initialState = () => ({ versionsOfInstallables: {} });

const state = initialState();

export default state;
